<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <el-container class="ContractManagementOcenter" :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>Ocenter合同管理</h2>
                    </el-col>
                    <el-col :span="12">
                        <el-popover
                            placement="bottom-start"
                            width="600"
                            trigger="manual"
                            v-model="visible"
                            popper-class="query">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="标的">
                                    <el-input v-model="queryform.title"></el-input>
                                </el-form-item>
                                <el-form-item label="公司名称">
                                    <el-input v-model="queryform.company"></el-input>
                                </el-form-item>
                                <el-form-item label="楼层/室号">
                                    <el-input v-model="queryform.room"></el-input>
                                </el-form-item>
                                <el-form-item label="合同类型">
                                    <!-- <el-input v-model="queryform.type"></el-input> -->
                                    <el-select v-model="queryform.type" placeholder="请选择" clearable>
                                        <el-option v-for="item in TypeList" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="合同状态">
                                    <!-- <el-input v-model="queryform.type"></el-input> -->
                                    <el-select v-model="queryform.status" placeholder="请选择" clearable>
                                        <el-option v-for="item in StatusList" :key="item.id" :label="item.cName" :value="item.cName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="缴费周期">
                                    <!-- <el-input v-model="queryform.type"></el-input> -->
                                    <el-select v-model="queryform.zhouqi" placeholder="请选择" clearable>
                                        <el-option label="年" :value="1">
                                        </el-option>
                                        <el-option label="月" :value="2">
                                        </el-option>
                                        <el-option label="季度" :value="3">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddContract">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" :height="Height - 265" border style="width: 100%">
                    <el-table-column prop="title" label="标的" width="200">
                    </el-table-column>
                    <el-table-column prop="company_name" label="公司名称" width="200">
                    </el-table-column>
                    <el-table-column prop="room" label="楼层/室号" width="120">
                    </el-table-column>
                    <el-table-column prop="contact" label="联系人" width="150">
                    </el-table-column>
                    <el-table-column prop="tel" label="联系电话" width="150">
                    </el-table-column>
                    <el-table-column prop="email" label="邮箱" width="200">
                    </el-table-column>
                    <!-- <el-table-column prop="title" label="合同标题" show-overflow-tooltip>
                    </el-table-column> -->
                    <el-table-column prop="type" label="合同类型" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 1">办公合同</span>
                            <span v-if="scope.row.type === 2">商业合同</span>
                            <span v-if="scope.row.type === 3">车位合同</span>
                            <span v-if="scope.row.type === 4">仓库合同</span>
                            <span v-if="scope.row.type === 5">Ocenter合同</span>
                            <span v-if="scope.row.type === 6">其他合同</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="合同状态" width="100">
                    </el-table-column>
                    <el-table-column prop="zhouqi" label="缴费周期" width="120">
                        <template slot-scope="scope">
                            <span v-if="Number(scope.row.zhouqi) === 1">年</span>
                            <span v-if="Number(scope.row.zhouqi) === 2">月</span>
                            <span v-if="Number(scope.row.zhouqi) === 3">季度</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="yajin" label="保证金" width="120" align="right">
                        <template slot-scope="scope">
                            <span>{{get_thousand_num(scope.row.yajin)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="wyf" label="物业管理费" width="120" align="right">
                        <template slot-scope="scope">
                            <span>{{get_thousand_num(scope.row.wyf)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="jiezhi" label="缴费截止日期" width="120">
                    </el-table-column>
                    <el-table-column prop="zhifu" label="支付方式" width="120">
                    </el-table-column>
                    <el-table-column prop="shoufuriqi" label="首付款日期" width="120">
                    </el-table-column>
                    <el-table-column prop="shoufujine" label="首付款金额" width="120" align="right">
                        <template slot-scope="scope">
                            <span>{{get_thousand_num(scope.row.shoufujine)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="yuezu" label="月租金" width="120" align="right">
                        <template slot-scope="scope">
                            <span>{{get_thousand_num(scope.row.yuezu)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tixingri" label="缴费提醒时间" width="120">
                    </el-table-column>
                    <el-table-column prop="fapiao" label="发票类型" width="120">
                    </el-table-column>
                    <el-table-column prop="dateS" label="合同开始时间" width="150">
                        <template slot-scope="scope">
                            {{scope.row.dateS.split(' ')[0]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="dateE" label="合同结束时间" width="150">
                        <template slot-scope="scope">
                            {{scope.row.dateE.split(' ')[0]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip width="200">
                    </el-table-column>
                    <el-table-column prop="address" label="操作" align="center" width="150" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="EditContract(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="DeleteContract(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="Contract" :fullscreen="fullscreen" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Contract">
                    <div slot="title" class="dialog-title" @click.stop>
                        <div class="title">
                            <span>{{title}}</span>
                        </div>
                        <i class="iconfont" @click="fullscreen = !fullscreen" :class="{'icon-quanping1':fullscreen===false, 'icon-tuichuquanping': fullscreen}"></i>
                    </div>
                    <div :style="fullscreenstyle()" class="ContractData">
                        <el-form :model="formData" ref="ruleform" :rules="rules" label-width="120px">
                            <el-form-item label="标的" prop="title">
                            <el-input v-model="formData.title" placeholder="请输入标的"></el-input>
                            </el-form-item>
                            <el-form-item label="公司" prop="company_id">
                                <el-select v-model="formData.company_id" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="changecompany">
                                    <el-option v-for="item in CompanyList" :key="item.id" :label="item.title" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="楼层/室号" prop="room">
                            <el-input v-model="formData.room" placeholder="请输入楼层/室号"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人">
                            <el-input v-model="formData.contact" placeholder="请输入联系人"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" prop="tel">
                            <el-input v-model="formData.tel" placeholder="请输入联系电话"></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="email">
                            <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
                            </el-form-item>
                            <el-form-item label="合同类型" prop="type">
                            <el-select v-model="formData.type" placeholder="请选择合同类型">
                                    <el-option v-for="item in TypeList" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="合同状态" prop="status">
                            <el-select v-model="formData.status" placeholder="请选择合同状态">
                                    <el-option v-for="item in StatusList" :key="item.id" :label="item.cName" :value="item.cName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="合同期限" prop="date">
                            <el-date-picker
                                    v-model="formData.date"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="缴费周期" prop="zhouqi">
                            <el-select v-model="formData.zhouqi" placeholder="请选择缴费周期">
                                    <el-option label="年" :value="1">
                                    </el-option>
                                    <el-option label="月" :value="2">
                                    </el-option>
                                    <el-option label="季度" :value="3">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="缴费截止日期" prop="jiezhi">
                                <el-date-picker
                                    v-model="formData.jiezhis"
                                    type="date"
                                    v-show="!jiezhiTrue"
                                    ref="jiezhi"
                                    @blur="jiezhiBlur"
                                    @change="jiezhiChange"
                                    placeholder="选择缴费截止日期">
                                </el-date-picker>
                            <el-input v-model="formData.jiezhi" prefix-icon="el-icon-date" v-show="jiezhiTrue" placeholder="选择缴费截止日期" @focus="jiezhiFocus"></el-input>
                            </el-form-item>
                            <el-form-item label="支付方式" prop="zhifu">
                            <!-- <el-input v-model="formData.zhifu" placeholder="请输入支付方式"></el-input> -->
                            <el-select v-model="formData.zhifu" placeholder="请选择支付方式">
                                    <el-option v-for="item in PaymentList" :key="item.id" :label="item.cName" :value="item.cName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="首付款日期" prop="shoufuriqi">
                            <!-- <el-input v-model="formData.shoufuriqi" placeholder="请选择首付款日期"></el-input> -->
                            <el-date-picker
                                    v-model="formData.shoufuriqi"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择首付款日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="首付款金额" prop="shoufujine" class="money">
                            <el-input v-model="formData.shoufujine" placeholder="请输入首付款金额"></el-input>
                            </el-form-item>
                            <el-form-item label="月租金" prop="yuezu" class="money">
                            <el-input v-model="formData.yuezu" placeholder="请输入月租金"></el-input>
                            </el-form-item>
                            <el-form-item label="缴费提醒时间" prop="tixingri">
                            <el-input v-model="formData.tixingri" prefix-icon="el-icon-date" v-show="tixingriTrue" @focus="tixingriFocus" placeholder="请选择缴费提醒时间"></el-input>
                            <el-date-picker
                                    v-show="!tixingriTrue"
                                    v-model="formData.tixingris"
                                    type="date"
                                    ref="tixingri"
                                    @blur="tixingriBlur"
                                    @change="tixingriChange"
                                    placeholder="请选择缴费提醒时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="保证金" prop="yajin" class="money">
                            <el-input v-model="formData.yajin" placeholder="请输入保证金"></el-input>
                            </el-form-item>
                            <el-form-item label="物业管理费" prop="wyf" class="money">
                            <el-input v-model="formData.wyf" placeholder="请输入物业管理费"></el-input>
                            </el-form-item>
                            <!-- cover -->
                            <el-form-item label="发票类型" prop="fapiao">
                            <!-- <el-input v-model="formData.title" placeholder="请输入标题"></el-input> -->
                            <el-select v-model="formData.fapiao" placeholder="请选择发票类型">
                                    <el-option v-for="item in radioData" :key="item.id" :label="item.cName" :value="item.cName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="收款提醒时间">
                            <el-input v-model="formData.dateD" placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="备注">
                            <el-input type="textarea" v-model="formData.remark" placeholder="请输入备注"></el-input>
                            </el-form-item>
                            <el-form-item label="附件">
                            <el-upload
                                    class="upload-demo"
                                    :action="http + '/Spaceorder/upload_file'"
                                    :data="Uploaddata"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    :on-success="ContractUploadSuccess"
                                    :before-upload="ContractBeforeUpload"
                                    multiple
                                    :limit="5"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <el-table :data="formData.detail" :height="155" border style="width: 100%">
                            <el-table-column type="index" width="50" label="序号" align="center">
                            </el-table-column>
                            <el-table-column min-width="140" label="提租开始日期">
                                <template slot-scope="scope">
                                    <el-date-picker v-model="scope.row.tizuriqi" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="140" label="提租结束日期">
                                <template slot-scope="scope">
                                    <el-date-picker v-model="scope.row.tizuriqi1" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="140" label="提租比例(%)">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.tizubili" placeholder="请输入提租比例"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="170" label="提租日租金(元/M²/日)">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.tizurizu" placeholder="请输入提租日租金"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="150" label="提租月租金(元/月)">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.tizuyuezu" placeholder="请输入提租月租金"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="100" label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-tooltip class="item" effect="dark" content="增行" placement="top" :open-delay="500">
                                        <el-button icon="el-icon-plus" type="text" style="padding: 0px;" @click="Adddetail(scope.$index)"></el-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="删行" placement="top" :open-delay="500">
                                        <el-button icon="el-icon-close" type="text" :disabled="scope.$index === 0" style="padding: 0px;"  @click="Closedetail(scope.$index)"></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirm" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="预览" :visible.sync="preview" width="800px">
                    <img v-if="type === 1" :src="urls + url">
                    <video v-if="type === 2" :src="urls + url"></video>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
/*eslint-disable */
export default {
    name: "ContractManagementOcenter",
    data() {
        return {
            urls: https.http,
            fileList: [],
            tableData: [],
            currentPage: 1,
            Size: 20,
            total: 1,
            Contract: false,
            title: '',
            formData: {
                title: '',
                contact: '',
                tel: '',
                type: 5,
                intro: '',
                room: '',
                company_name: '',
                remark: '',
                date: [],
                dateS: '',
                dateS: '',
                status: '正常',
                img: [],
                company_id: '',
                room: '',
                zhouqi: '',
                jiezhi: '',
                zhifu: '',
                shoufuriqi: '',
                shoufujine: '',
                yuezu: '',
                tixingri: '',
                yajin: '',
                wyf: '',
                fapiao: '',
                jiezhis: '',
                tixingris: '',
                detail: [{
                    tizuriqi: '', // 提租开始日期
                    tizuriqi1: '', // 提租结束日期
                    tizubili: '', // 提租比例(%)"
                    tizurizu: '', // 提租日租金(元/M²/日)
                    tizuyuezu: '', // 提租月租金(元/月),
                    iOrder: 1
                }]
            },
            TypeList: [{
                label: 'Ocenter合同',
                value: 5
            }],
            StatusList: [],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            type: 1,
            url: '',
            confirmloding: false,
            fullscreenLoading: false,
            queryform: {
                title: '',
                room: '',
                company: '',
                type: '',
                status: '',
                zhouqi: ''
            },
            visible: false,
            CompanyList: [],
            loading: false,
            rules: {
                title: [
                    { required: true, message: '请输入标的', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择合同类型', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择合同状态', trigger: 'blur' }
                ],
                company_id: [
                    { required: true, message: '请选择公司', trigger: 'blur' }
                ],
                room: [
                    { required: true, message: '请输入楼层', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' }
                ],
                zhouqi: [
                    { required: true, message: '请选择缴费周期', trigger: 'blur' }
                ],
                jiezhi: [
                    { required: true, message: '选择缴费截止日期', trigger: 'blur' }
                ],
                zhifu: [
                    { required: true, message: '请输入支付方式', trigger: 'blur' }
                ],
                shoufuriqi: [
                    { required: true, message: '请选择首付款日期', trigger: 'blur' }
                ],
                shoufujine: [
                    { required: true, message: '请输入首付款金额', trigger: 'blur' }
                ],
                yuezu: [
                    { required: true, message: '请输入月租金', trigger: 'blur' }
                ],
                tixingri: [
                    { required: true, message: '请选择缴费提醒时间', trigger: 'blur' }
                ],
                yajin: [
                    { required: true, message: '请输入押金', trigger: 'blur' }
                ],
                fapiao: [
                    { required: true, message: '请选择发票类型', trigger: 'blur' }
                ],
                date: [
                    { required: true, message: '请选择合同期限', trigger: 'change' }
                ]
            },
            radioData: [],
            jiezhiTrue: true,
            tixingriTrue: true,
            PaymentList: [],
            fullscreen: true
        };
    },
    mounted() {},
    watch: {},
    methods: {
        fullscreenstyle () {
            let style = {}
            if (this.fullscreen === false) {
                style.height = '60vh' 
            } else {
                style.height = 'calc(100vh - 120px)'
            }
            return style
        },
        Adddetail (index) {
            let data = {
                tizuriqi: '', // 提租开始日期
                tizuriqi1: '', // 提租结束日期
                tizubili: '', // 提租比例(%)"
                tizurizu: '', // 提租日租金(元/M²/日)
                tizuyuezu: '', // 提租月租金(元/月)
                iOrder: 1
            }
            this.formData.detail.splice(index + 1, 0, JSON.parse(JSON.stringify(data)))
            for (let item in this.formData.detail) {
                this.formData.detail[item].iOrder = Number(JSON.parse(JSON.stringify(item)))
            }
        },
        Closedetail (index) {
            this.formData.detail.splice(index, 1)
            for (let item in this.formData.detail) {
                this.formData.detail[item].iOrder = Number(JSON.parse(JSON.stringify(item)))
            }
        },
        get_thousand_num (num) {
            return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
                    return $1 + ','
                })
            })
        },
        jiezhiFocus (e) {
            this.jiezhiTrue = false
            e.target.blur()
            setTimeout(() => {
                this.$refs.jiezhi.focus()
            }, 100)
        },
        tixingriFocus (e) {
            this.tixingriTrue = false
            e.target.blur()
            setTimeout(() => {
                this.$refs.tixingri.focus()
            }, 100)
        },
        jiezhiBlur () {
            this.jiezhiTrue = true
        },
        tixingriBlur() {
            this.tixingriTrue = true
        },
        jiezhiChange () {
            this.formData.jiezhi = this.formData.jiezhis.getDate()
        },
        tixingriChange () {
            this.formData.tixingri = this.formData.tixingris.getDate()
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                title: '',
                room: '',
                company: '',
                type: '',
                status: '',
                zhouqi: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.fullscreenLoading = true
            this.GetContractList()
        },
        change (val) {
        },
        handleClick() {
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetContractList()
        },
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.fullscreenLoading = true
            this.GetContractList()
        },
        GetContractList() {
            let data = JSON.parse(JSON.stringify(this.queryform))
            data.limit = this.Size
            data.page = this.currentPage
            data.ADMIN_ID = getAdminId()
            data.ADMIN_TOKEN = getToken()
            this.$store.dispatch('GetContractOcenterListShow', data).then(res => {
                this.fullscreenLoading = false
                this.visible = false
                this.tableData = res.data
                this.total = res.something
            })
        },
        cancel() {
            console.log(this.Contract)
            this.Contract = false
        },
        confirm() {
            let that = this
            // console.log(this.formData)
            this.$refs['ruleform'].validate((valid) => {
                if (valid) {
                    that.confirmloding = true
                    let data = JSON.parse(JSON.stringify(this.formData))
                    data.ADMIN_ID = getAdminId();
                    data.ADMIN_TOKEN = getToken();
                    data.dateS = data.date[0]
                    data.dateE = data.date[1]
                    data.img = JSON.stringify(data.img)
                    if (data.company_id !== '') {
                        for (let item in that.CompanyList) {
                            if (that.CompanyList[item].id === data.company_id) {
                                data.company_name = that.CompanyList[item].title
                            }
                        }
                    }
                    data.detail = JSON.stringify(data.detail)
                    // console.log(data)
                    that.$store.dispatch('SaveContract', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.Contract = false
                            that.fullscreenLoading = true
                            that.GetContractList()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        AddContract() {
            this.title = '新增合同'
            this.Contract = true
            this.GetCompanyList()
            this.formData = {
                title: '',
                contact: '',
                tel: '',
                type: 5,
                intro: '',
                room: '',
                company_name: '',
                remark: '',
                date: [],
                dateS: '',
                dateS: '',
                status: '正常',
                img: [],
                company_id: '',
                room: '',
                zhouqi: '',
                jiezhi: '',
                zhifu: '',
                shoufuriqi: '',
                shoufujine: '',
                yuezu: '',
                tixingri: '',
                yajin: '',
                wyf: '',
                fapiao: '',
                jiezhis: '',
                tixingris: '',
                detail: [{
                    tizuriqi: '', // 提租开始日期
                    tizuriqi1: '', // 提租结束日期
                    tizubili: '', // 提租比例(%)"
                    tizurizu: '', // 提租日租金(元/M²/日)
                    tizuyuezu: '', // 提租月租金(元/月),
                    iOrder: 1
                }]
            }
            this.fileList = []
        },
        handlePreview(file) {
            console.log(file)
            let str = file.response.split('.').pop()
            console.log(str)
            if (str === 'image/jpeg' || str === 'image/png') {
                this.type = 1
            } else if (str === 'pdf' || str === 'mp4') {
                this.type = 2
                let url = this.urls + file.response
                let link = document.createElement('a')
                link.target = '_blank'
                link.href = url
                link.click()
            }
            this.url = file.response
            if (this.type === 1) {
                this.preview = true
            }
        },
        handleRemove(file, fileList) {
            this.formData.img = fileList
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        ContractBeforeUpload(file) {
            return true
        },
        ContractUploadSuccess(response, file, fileList) {
            // console.log(fileList)
            this.formData.img = fileList
        },
        EditContract(row) {
            this.title = '编辑合同'
            this.Contract = true
            this.GetCompanyList()
            this.formData = JSON.parse(JSON.stringify(row))
            this.fileList = JSON.parse(this.formData.img)
            this.formData.img = JSON.parse(this.formData.img)
            if (this.formData.detail === null || this.formData.detail === undefined || this.formData.detail === '') {
                this.formData.detail = [{
                    tizuriqi: '', // 提租开始日期
                    tizuriqi1: '', // 提租结束日期
                    tizubili: '', // 提租比例(%)"
                    tizurizu: '', // 提租日租金(元/M²/日)
                    tizuyuezu: '', // 提租月租金(元/月)
                    iOrder: 1
                }]
            } else {
                if (this.formData.detail instanceof Array) {
                    if (this.formData.detail.length === 0) {
                        this.formData.detail = [{
                            tizuriqi: '', // 提租开始日期
                            tizuriqi1: '', // 提租结束日期
                            tizubili: '', // 提租比例(%)"
                            tizurizu: '', // 提租日租金(元/M²/日)
                            tizuyuezu: '', // 提租月租金(元/月)
                            iOrder: 1
                        }]
                    }
                } else {
                    this.formData.detail = [{
                        tizuriqi: '', // 提租开始日期
                        tizuriqi1: '', // 提租结束日期
                        tizubili: '', // 提租比例(%)"
                        tizurizu: '', // 提租日租金(元/M²/日)
                        tizuyuezu: '', // 提租月租金(元/月)
                        iOrder: 1
                    }]
                }
                // this.formData.detail = JSON.parse(this.formData.detail)
            }
            let date = new Date()
            date.setDate(this.formData.jiezhi)
            this.$set(this.formData, "date", [ this.formData.dateS, this.formData.dateE]);
            this.$set(this.formData, "jiezhis", date);
            let dates = new Date()
            dates.setDate(this.formData.jiezhi)
            this.$set(this.formData, "tixingris", dates);
        },
        DeleteContract(row) {
            this.$confirm('是否删除该合同？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId()
                row.ADMIN_TOKEN = getToken()
                this.fullscreenLoading = true
                this.$store.dispatch('DeleteContract', row).then(res => {
                    if (res.flag) {
                        this.$message({
                            type: 'success',
                            message: res.message
                        })
                        this.GetContractList()
                    } else {
                        this.fullscreenLoading = false
                        this.$message({
                            type: 'warning',
                            message: res.message
                        })
                    }
                })
            }).catch(() => {
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    keyword: query,
                    room: '',
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                    status: 1
                }
                this.$store.dispatch('CompanyListShow', data).then(res => {
                    this.CompanyList = res.data
                    this.loading = false
                })
            } else {
                this.CompanyList = []
            }
        },
        GetCompanyList () {
            let data = {
                keyword: '',
                room: '',
                limit: 10000,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('CompanyListShow', data).then(res => {
                this.CompanyList = res.data
            })
        },
        GetTreeDataItem (e) {
            // this.enumpk = e
            let data = {
                PK_EY_Enum: "02e9cc26f999da546558aeb12ffbfd3c"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.radioData = res.data
            })
        },
        changecompany () {
            for (let item in this.CompanyList) {
                if (this.CompanyList[item].id === this.formData.company_id) {
                    this.formData.room = this.CompanyList[item].room
                }
            }
        },
        GetPayment() {
            let data = {
                PK_EY_Enum: "0141470a60c4747f6c38a492bc5bd8da"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.PaymentList = res.data
            })
        },
        Getstatus() {
            let data = {
                PK_EY_Enum: "01a68ada5850061a2fd4e078d3aa350b"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.StatusList = res.data
            })
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetCompanyList()
        this.GetContractList()
        this.GetTreeDataItem()
        this.Getstatus()
        this.GetPayment()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
};
</script>

<style>
.ContractManagementOcenter {
    width: 100%;
}
.ContractManagementOcenter .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.ContractManagementOcenter .el-header .el-row .el-col h2 {
    text-align: center;
}
.ContractManagementOcenter .el-header .el-row .el-col {
    padding-left: 10px;
}
.ContractManagementOcenter .el-header .el-row .el-col:last-child {
    text-align: right;
}
.ContractManagementOcenter .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
    /* height: 60vh; */
    overflow: auto;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item {
    display: inline-block;
    width: 100%;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item .el-select,.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item .el-date-editor {
    width: 100%;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(3), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(4),.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(5), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(6), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(7), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(8), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(10), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(11), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(12), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(13), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(14), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(15), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(16), .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .el-form-item:nth-child(17) {
    width: 50%;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-form .money input {
    text-align: right;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-table tr td .cell {
    padding: 0px;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-table tr td .cell .el-date-editor {
    width: 100%;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-table tr td .cell .el-input, .ContractManagementOcenter .el-main .Contract .el-dialog__body .el-table tr td .cell .el-input input {
    height: 30px;
    line-height: 30px;
}
.ContractManagementOcenter .el-main .Contract .el-dialog__body .el-table tr td .cell .el-date-editor .el-input__icon {
    line-height: 30px;
}
.query .el-select {
    width: 100%;
}
.query .el-form-item {
    display: inline-block;
    width: 50%;
}
.el-dialog .el-dialog__header .dialog-title  {
    color: #333;
    font-weight: 600;
    font-size: 16px;
    height: 20px;
}
.el-dialog .el-dialog__header .dialog-title .title {
    float: left;
}
.el-dialog .el-dialog__header .dialog-title i {
    float: right;
}
</style>
